// Issue with watermelonDB library https://github.com/Nozbe/WatermelonDB/issues/629
// @ts-nocheck
import { Model } from '@nozbe/watermelondb';
import { field, date, readonly } from '@nozbe/watermelondb/decorators';
import { setGenerator } from '@nozbe/watermelondb/utils/common/randomId';
import { v4 as uuidv4 } from 'uuid';

setGenerator(uuidv4);

export default class Answer extends Model {
    static table = 'answers';

    static associations = {
        questions: { type: 'belongs_to', key: 'question_id' },
        user_answers: { type: 'has_many', foreignKey: 'answer_id' },
    };

    @field('content') content;
    @field('question_id') questionId;
    @readonly @date('created_at') createdAt;
    @readonly @date('updated_at') updatedAt;
}

export type AnswerSimple = {
    id: string;
    content: string;
    questionId: string;
    createdAt: number;
    updatedAt: number;
};
